import _ from 'lodash';

export default function ChartTooltip({ active, payload, label }) {
    if (active && payload && payload.length) {
        return (
            <div style={{
                backgroundColor: '#1a2b3c',
                borderRadius: 8,
                padding: '10px 14px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                border: 'none',
                minWidth: 120,
            }}>
                {label && (
                    <p style={{
                        margin: '0 0 6px 0',
                        fontSize: '0.72rem',
                        fontWeight: 600,
                        color: '#94a3b8',
                        borderBottom: '1px solid rgba(255,255,255,0.1)',
                        paddingBottom: 6,
                    }}>
                        {label}
                    </p>
                )}
                {payload.map((row, i) => (
                    <p key={i} style={{
                        margin: '3px 0',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                    }}>
                        <span style={{
                            width: 8,
                            height: 8,
                            borderRadius: 2,
                            backgroundColor: row.color,
                            display: 'inline-block',
                            flexShrink: 0,
                        }} />
                        <span style={{color: '#94a3b8', fontWeight: 500}}>{row.name}:</span>
                        <span>{getValue(row.value)}{row.unit || ''}</span>
                    </p>
                ))}
            </div>
        );
    }

    return null;
}

function getValue(v) {
    if (_.isNumber(v)) {
        return new Intl.NumberFormat('en-IN').format(v)
    }

    return v
}
